import React from 'react';
import ReactDOM from 'react-dom/client';
import "./css/index.css";
import App from './App';
import { I18nProvider } from "./contexts/I18nContext";
// import reportWebVitals from './reportWebVitals'; // Removed: file does not exist

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider initialLanguage="en">
      <App />
    </I18nProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(); // Removed: file does not exist
